<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="短信模板" name="0"></el-tab-pane>
      <el-tab-pane label="编辑固定文本" name="1"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName == 0">
      <!--顶部工具条-->
      <el-col :span="24">
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              style="width: 170px"
              v-model="filters.name"
              placeholder="请输入模板名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 170px"
              v-model="filters.isEnable"
              placeholder="请选择号码状态"
              clearable
            >
              <el-option
                v-for="item in isEnableOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="tableData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%;"
        border
        @current-change="selectCurrentRow"
        class="custom-padding-table"
      >
        <el-table-column 
          prop="templateTitle"
          label="模板名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="templateContent"
          label="模板内容"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="isReview"
          label="短信平台审核状态"
          align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-tag type="success" v-if="scope.row.isReview == true">通过</el-tag>
            <el-tag type="info"  v-if="scope.row.isReview == false">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="isEnable"
          label="使用状态"
          align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-tag type="success" v-if="scope.row.isEnable == true">启用</el-tag>
            <el-tag type="info"  v-if="scope.row.isEnable == false">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createUser"
          label="创建人"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <!--底部工具条-->
      <el-col :span="24" class="pageBar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageIndex"
          :page-sizes="pages.pageArr"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.dataCount"
        >
        </el-pagination>
      </el-col>
    </div>

    <div v-if="activeName == 1">
      <!--顶部工具条-->
      <el-col :span="24">
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              style="width: 170px"
              v-model="filters2.templateName"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item style="margin-left: 20px">
            <el-button type="primary" @click="handleSearch2">搜索</el-button>
            <el-button type="primary" @click="handleAdd2">新增</el-button>
            <el-button type="primary" @click="handleEdit2">修改</el-button>
            <el-button type="danger" @click="handleDel2">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="tableData2"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        border
        @current-change="selectCurrentRow2"
        class="custom-padding-table"
        
      >
        <el-table-column
          prop="templateName"
          label="固定文本名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="templateValue"
          label="变量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="templateContent"
          label="固定文本内容"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createUserId"
          label="创建人"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <!--底部工具条-->
      <el-col :span="24" class="pageBar">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pages2.pageIndex"
          :page-sizes="pages2.pageArr"
          :page-size="pages2.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages2.dataCount"
        >
        </el-pagination>
      </el-col>
    </div>

    <!--短信模板新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
      
    >
      <div style="display: flex">
        <div class="left" style="width:50%;">
          <el-form
            :model="Form"
            label-width="100px"
            ref="Form"
            style="max-width: 700px"
            :rules="FormRules"
          >
            <el-form-item label="使用固定文本：" prop="">
              <el-radio-group v-model="radio" @input="inputChange">
                <el-radio label="1">是(请点击右侧固定文本)</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="模板名称：" prop="templateTitle">
              <el-input
                v-model="Form.templateTitle"
                auto-complete="off"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="短信内容：" prop="templateContent">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="Form.templateContent"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="模板参数定义：" prop="templateParam">
              <el-input
                :rows="2"
                placeholder='(如[{"name": "value","ismust":"1"}],ismust值为1必填,为0不填)'
                v-model="Form.templateParam"
              >
              </el-input>
            </el-form-item>
            <div style="display: flex">
              <el-form-item label="短信平台审核状态：" prop="isReview">
                <el-radio-group v-model="Form.isReview">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="模板编码"
                prop="templateCode"
                v-if="Form.isReview == true"
              >
                <el-input
                  :rows="2"
                  placeholder="请输入"
                  v-model="Form.templateCode"
                />
              </el-form-item>
            </div>

            <el-form-item label="使用状态：" prop="isEnable">
              <el-radio-group v-model="Form.isEnable">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div class="right" style="margin-left: 10px;width:50%;" v-if="radio == 1">
          <el-table
            :data="tableData3"
            highlight-current-row
            v-loading="listLoading"
            style="width: 100%"
            border
            @current-change="selectCurrentRow3"
          >
            <el-table-column
              prop="templateName"
              label="模板名称"
              align="center"
              show-overflow-tooltip
            ></el-table-column>

            <el-table-column
              prop="templateContent"
              label="固定文本内容"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <!--底部工具条-->
          <el-col :span="24" class="pageBar">
            <el-pagination
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="pages3.pageIndex"
              :page-sizes="pages3.pageArr"
              :page-size="pages3.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pages3.dataCount"
            >
            </el-pagination>
          </el-col>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--固定文本新增界面-->
    <el-dialog
      :title="editmark2 == true ? '编辑' : '新增'"
      :visible.sync="FormVisible2"
      v-model="FormVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        :model="Form2"
        label-width="100px"
        ref="Form2"
        style="max-width: 700px"
        :rules="FormRules2"
      >
        <el-form-item label="固定文本名称" prop="templateName">
          <el-input
            v-model="Form2.templateName"
            auto-complete="off"
            placeholder="请输入固定文本名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="templateContent">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入固定文本内容"
            v-model="Form2.templateContent"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="变量: " prop="templateValue">
          <el-input
            v-model="Form2.templateValue"
            auto-complete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible2 = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit2"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getNoticeTemplateListPageApi,
  addNoticeTemplateApi,
  updateNoticeTemplateApi,
  delNoticeTemplateApi,
  getSmsTemplateFixedListApi,
  addSmsTemplateFixedApi,
  updateSmsTemplateFixedApi,
  delSmsTemplateFixedApi,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      tableData2: [],
      tableData3: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        name: "",
        isEnable: "",
      },
      //顶部筛选条件
      filters2: {
        templateName: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      //关于分页的obj
      pages2: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      pages3: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },

      isEnableOptions: [
        {
          value: true,
          label: "启用",
        },
        {
          value: false,
          label: "禁用",
        },
      ],
      FormVisible: false,
      Form: {
        templateTitle: "",
        templateContent: "",
        templateParam: "",
        templateCode: "",
        isReview: false,
        isEnable: false,
      },
      FormRules: {
        templateTitle: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
        templateContent: [
          { required: true, message: "请选择短信内容", trigger: "blur" },
        ],
        templateParam: [
          { required: true, message: "请填写模板参数", trigger: "blur" },
        ],
        templateCode: [
          { required: true, message: "请填写模板编码", trigger: "blur" },
        ],
      },
      currentRow: "",
      currentRow2: "",
      currentRow3: "",
      editmark: false,
      editmark2: false,
      activeName: 0,
      FormVisible2: false,
      Form2: {
        templateName: "",
        templateValue: "",
        templateContent: "",
      },
      FormRules2: {
        templateName: [
          { required: true, message: "请输入固定文本名称", trigger: "blur" },
        ],
        templateContent: [
          { required: true, message: "请输入固定文本内容", trigger: "blur" },
        ],
        templateValue: [
          { required: true, message: "请输入变量", trigger: "blur" },
        ],
      },
      radio: "0",
    };
  },
  methods: {
    // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    handleSearch2() {
      this.pages2.pageIndex = 1;
      this.getSmsTemplateFixedList();
    },
    inputChange(e) {
      if (e == 0) {
        this.Form.templateTitle = "";
        this.Form.templateContent = "";
      }
    },
    // 切换tab
    handleClick(e) {
      this.activeName = e.index;
      if (this.activeName == 0) {
        this.getList();
        this.getSmsTemplateFixedListAll();
      }
      if (this.activeName == 1) {
        this.getSmsTemplateFixedList();
      }
    },
    // 导出模板
    exportMessageExcel() {
      this.listLoading = true;
      function createObjectURL(object) {
        return window.URL
          ? window.URL.createObjectURL(object)
          : window.webkitURL.createObjectURL(object);
      }
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      xhr.open(
        "GET",
        `/omswebapi/message/exportMessageExcel?isAll=${
          this.exportExcelRadio
        }&startDate=${
          this.rangeTimers
            ? this.formatCreateTime(this.rangeTimers[0]) + " 00:00:00"
            : null
        }&endDate=${
          this.rangeTimers
            ? this.formatCreateTime(this.rangeTimers[1]) + " 23:59:59"
            : null
        }`,
        true
      );
      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${window.localStorage.getItem("Token")}`
      );
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = `聊天记录导出.xlsx`;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement("a");
            var url = createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
      this.listLoading = false;
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };

      getNoticeTemplateListPageApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },
    getSmsTemplateFixedList() {
      var params = {
        templateName: this.filters2.templateName,
        pageIndex: this.pages2.pageIndex,
        pageSize: this.pages2.pageSize,
      };
      getSmsTemplateFixedListApi(params).then((res) => {
        this.tableData2 = res.data.response.data;
        this.pages2.dataCount = res.data.response.dataCount;
      });
    },
    getSmsTemplateFixedListAll() {
      var params = {
        pageIndex: this.pages3.pageIndex,
        pageSize: this.pages3.pageSize,
      };
      getSmsTemplateFixedListApi(params).then((res) => {
        this.tableData3 = res.data.response.data;
        this.pages3.dataCount = res.data.response.dataCount;
      });
    },
    selectCurrentRow(row) {
      this.currentRow = row;
    },
    selectCurrentRow2(row) {
      this.currentRow2 = row;
    },
    selectCurrentRow3(row) {
      console.log("CurrentRow3", row);
      this.currentRow3 = row;
      this.Form.templateTitle = row.templateName;
      this.Form.templateContent = row.templateContent;
    },
    handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
        this.radio = "0";
      this.editmark = true;
      // 深拷贝一下
      this.Form = { ...this.currentRow };
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.radio = "0";
      this.Form = {
        templateTitle: "",
        templateContent: "",
        templateParam: "",
        templateCode: "",
        isReview: false,
        isEnable: false,
      };
      this.editmark = false;
      this.FormVisible = true;
    },

    handleDel() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要删除的的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        let params = {
          id: this.currentRow.id,
        };
        this.listLoading = true;
        delNoticeTemplateApi(params).then((res) => {
          if (res.data.success) {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
             // 👇👇👇【核心逻辑开始】👇👇👇
            // 1. 获取当前页展示的数据条数
            const currentPageSize = this.tableData.length;
            
            // 2. 判断：如果是当前页的最后一条数据 (长度为1) 且 不是第一页 (pageIndex > 1)
            if (currentPageSize === 1 && this.pages.pageIndex > 1) {
              // 页码减 1，跳回上一页
              this.pages.pageIndex--;
            }
            // 👆👆👆【核心逻辑结束】👆👆
            this.getList();
          } else {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },
    handleDel2() {
      if (!this.currentRow2) {
        this.$message({
          message: "请选择要删除的的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        let params = {
          id: this.currentRow2.id,
        };
        this.listLoading = true;
        delSmsTemplateFixedApi(params).then((res) => {
          if (res.data.success) {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
            // 👇👇👇【核心逻辑开始】👇👇👇
            // 1. 获取当前页展示的数据条数
            const currentPageSize = this.tableData2.length;

            // 2. 判断：如果是当前页的最后一条数据 (长度为1) 且 不是第一页 (pageIndex > 1)
            if (currentPageSize === 1 && this.pages2.pageIndex > 1) {
              // 页码减 1，跳回上一页
              this.pages2.pageIndex--;
            }
            // 👆👆👆【核心逻辑结束】👆👆
            this.getSmsTemplateFixedList();
          } else {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
           if(this.Form.isReview==false){
              this.Form.templateCode=''
           }
            let params = {
              ...this.Form,
            };
            if (this.editmark) {
              updateNoticeTemplateApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addNoticeTemplateApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.handleSearch();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },
    //提交新增表单
    FormSubmit2() {
      this.$refs.Form2.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            let params = {
              ...this.Form2,
            };
            if (this.editmark2) {
              updateSmsTemplateFixedApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form2"].clearValidate();
                  this.FormVisible2 = false;
                  this.getSmsTemplateFixedList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addSmsTemplateFixedApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form2"].clearValidate();
                  this.FormVisible2 = false;
                  this.handleSearch2();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },
    handleAdd2() {
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form2) {
          this.$refs.Form2.clearValidate();
        }
      });
      this.Form2 = {
        templateName: "",
        templateValue: "",
        templateContent: "",
      };
      this.editmark2 = false;
      this.FormVisible2 = true;
    },
    handleEdit2() {
      if (!this.currentRow2) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form2) {
          this.$refs.Form2.clearValidate();
        }
      });
      this.editmark2 = true;
      // 深拷贝一下
      this.Form2 = { ...this.currentRow2 };
      this.FormVisible2 = true;
    },

    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
    // 分页
    handleCurrentChange2(val) {
      this.pages2.pageIndex = val;
      this.getSmsTemplateFixedList();
    },
    handleSizeChange2(val) {
      this.pages2.pageSize = val;
      this.getSmsTemplateFixedList();
    },
    // 分页
    handleCurrentChange3(val) {
      this.pages3.pageIndex = val;
      this.getSmsTemplateFixedListAll();
    },
    handleSizeChange3(val) {
      this.pages3.pageSize = val;
      this.getSmsTemplateFixedListAll();
    },
  },
  mounted() {
    this.getList();
    this.getSmsTemplateFixedListAll();
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */

</style>
